<template>
	<div class="loader loader--block">
		<div class="loader__icon"></div>
	</div>
</template>

